(function () {
  function extractDisplayedPrice(container) {
    if (!container) return '';
    var sale = container.querySelector('.price__sale');
    var regular = container.querySelector('.price__regular');
    var visible = sale && sale.offsetParent !== null ? sale : regular;
    if (!visible) return container.textContent.replace(/\s+/g, ' ').trim();
    var items = visible.querySelectorAll('.price-item');
    var text = '';
    for (var i = 0; i < items.length; i++) {
      if (!items[i].closest('s')) text = items[i].textContent.replace(/\s+/g, ' ').trim();
    }
    return text || visible.textContent.replace(/\s+/g, ' ').trim();
  }

  function initStickyAddToCart(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var button = document.getElementById('StickyAddToCartButton-' + sectionId);
    var buttonText = button ? button.querySelector('.sticky-add-to-cart__button-text') : null;
    var priceEl = document.getElementById('StickyAddToCartPrice-' + sectionId);
    var imageEl = document.getElementById('StickyAddToCartImage-' + sectionId);
    var realButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var realPriceRoot = document.getElementById('price-' + sectionId);
    var mediaWrapper = document.querySelector('#MainProduct-' + sectionId + ' .product__media-wrapper');

    if (!button || !realButton) return;

    button.addEventListener('click', function () {
      if (!button.disabled && !realButton.disabled) realButton.click();
    });

    function syncButtonState() {
      var isDisabled = realButton.disabled || realButton.hasAttribute('disabled');
      button.disabled = isDisabled;
      if (buttonText) {
        var realTextEl = realButton.querySelector('span');
        var label = realTextEl ? realTextEl.textContent : realButton.textContent;
        buttonText.textContent = label.replace(/\s+/g, ' ').trim();
      }
    }
    syncButtonState();
    if (window.MutationObserver) {
      new MutationObserver(syncButtonState).observe(realButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    function syncPrice() {
      if (!priceEl || !realPriceRoot) return;
      var text = extractDisplayedPrice(realPriceRoot);
      if (text) priceEl.textContent = text;
    }
    if (realPriceRoot) {
      syncPrice();
      if (window.MutationObserver) {
        new MutationObserver(syncPrice).observe(realPriceRoot, { childList: true, subtree: true, characterData: true });
      }
    }

    function syncImage() {
      if (!imageEl || !mediaWrapper) return;
      var img = mediaWrapper.querySelector('img');
      var src = img && (img.currentSrc || img.src);
      if (src) imageEl.src = src;
    }
    if (mediaWrapper) {
      syncImage();
      if (window.MutationObserver) {
        new MutationObserver(syncImage).observe(mediaWrapper, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['src', 'srcset']
        });
      }
    }

    // ── Visibility: driven directly by scroll-position geometry instead of
    // IntersectionObserver, which can miss fast/inertial scrolls and whose
    // callback timing is unreliable across browsers. This is checked on every
    // scroll/resize frame (rAF-throttled) so it can never get "stuck".
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var footer = document.querySelector('footer, #shopify-section-footer, .footer');

    function updateVisibility() {
      if (!mobileQuery.matches) {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
        return;
      }
      var btnRect = realButton.getBoundingClientRect();
      var buttonAboveViewport = btnRect.bottom < 0;

      var footerVisible = false;
      if (footer) {
        var fRect = footer.getBoundingClientRect();
        footerVisible = fRect.top < window.innerHeight;
      }

      var shouldShow = buttonAboveViewport && !footerVisible;
      root.classList.toggle('is-visible', shouldShow);
      root.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    var ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updateVisibility);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(updateVisibility);
    }

    // Establish correct initial state (e.g. deep-linked scroll position, or
    // a page restored mid-scroll from the browser's back/forward cache).
    updateVisibility();
  }

  function boot() {
    var roots = document.querySelectorAll('.sticky-add-to-cart');
    for (var i = 0; i < roots.length; i++) initStickyAddToCart(roots[i]);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
